export enum NotificationTypeEnumes {
  ACTIVITY = 'New activities',
  SURVEYS = 'New surveys',
  STUDIES = 'New studies',
}

export enum NotificationSendTypeEnumes {
  USER = 'user',
  TOPIC = 'topic',
}
